export const VALID_EMAIL_REGEX: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const VALID_URL_REGEX: RegExp =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;

// source: https://github.com/mnestorov/regex-patterns?tab=readme-ov-file
export const VALID_VAT_NO_REGEX: Record<string, [RegExp, string]> = {
  AT: [/^ATU\d{8}$/, 'ATU12345678'],
  BE: [/^BE[01]\d{9}$/, 'BE0123456789'],
  BG: [/^BG\d{9,10}$/, 'BG123456789'],
  CH: [/^CHE\d{9}(MWST|TVA|IVA)$/, 'CHE123456789MWST'],
  CY: [/^CY\d{8}[A-Z]$/, 'CY12345678X'],
  CZ: [/^CZ\d{8,10}$/, 'CZ12345678'],
  DE: [/^DE\d{9}$/, 'DE123456789'],
  DK: [/^DK\d{8}$/, 'DK12345678'],
  EE: [/^EE\d{9}$/, 'EE123456789'],
  ES: [
    /^ES[A-Z]\d{7}[A-Z]$|^ES[A-Z][0-9]{7}[0-9A-Z]$|^ES[0-9]{8}[A-Z]$/,
    'ESX1234567Y',
  ],
  FI: [/^FI\d{8}$/, 'FI12345678'],
  FR: [/^FR[A-HJ-NP-Z0-9]{2}\d{9}$/, 'FR12AB34567'],
  GR: [/^EL\d{9}$/, 'EL123456789'],
  HR: [/^HR\d{11}$/, 'HR12345678901'],
  HU: [/^HU\d{8}$/, 'HU12345678'],
  IE: [/^IE\d{7}[A-WY][A-I]?$|^IE[0-9+][A-Z+][0-9]{5}[A-WY]$/, 'IE1234567A'],
  IT: [/^IT\d{11}$/, 'IT12345678901'],
  LT: [/^LT\d{9,12}$/, 'LT123456789'],
  LU: [/^LU\d{8}$/, 'LU12345678'],
  LV: [/^LV\d{11}$/, 'LV12345678901'],
  MT: [/^MT\d{8}$/, 'MT12345678'],
  NL: [/^NL\d{9}B\d{2}$/, 'NL123456789B01'],
  PL: [/^PL\d{10}$/, 'PL1234567890'],
  PT: [/^PT\d{9}$/, 'PT123456789'],
  RO: [/^RO\d{10}$/, 'RO1234567890'],
  SE: [/^SE\d{12}$/, 'SE123456789012'],
  SI: [/^SI\d{8}$/, 'SI12345678'],
  SK: [/^SK\d{10}$/, 'SK1234567890'],
};
